import { render, staticRenderFns } from "./add-logistics.vue?vue&type=template&id=031fd4d0&scoped=true"
import script from "./add-logistics.ts?vue&type=script&lang=ts&external"
export * from "./add-logistics.ts?vue&type=script&lang=ts&external"
import style0 from "./add-logistics.scoped.scss?vue&type=style&index=0&id=031fd4d0&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031fd4d0",
  null
  
)

export default component.exports